import React, { useEffect, useState } from "react";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import { useTranslation } from "react-i18next";
import { Container, Image, Spinner, Table } from "react-bootstrap";
import {
  MdAddCircleOutline,
  MdDeleteOutline,
  MdOutlineCategory,
  MdOutlineEdit,
} from "react-icons/md";
import ModalCreateUpdate from "../../components/admin/engagement/ModalCreateUpdate";
import { apiGetEngagements } from "../../api/ApiEngagement";
import { useSelector } from "react-redux";
import ModalDelete from "../../components/admin/engagement/ModalDelete";
import ModalChoixOrgunits from "../../components/admin/engagement/ModalChoixOrgunits";

const PageAdminEngagements = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [loading, setLoading] = useState(false);
  const [idEngagement, setIdEngagement] = useState("");
  const [showCreateUpdate, setShowCreateUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [engagements, setEngagements] = useState([]);
  const [showOrgunits, setShowOrgunits] = useState(false);

  const recupEngagements = async () => {
    setLoading(true);
    const res = await apiGetEngagements(ReduxInstance._id);
    if (res) {
      setEngagements(res.data);
      setLoading(false);
    } else {
      console.log("Error");
    }
  };

  const handleShowCreateUpdate = (id) => {
    setIdEngagement(id);
    setShowCreateUpdate(true);
  };

  const handleCloseCreateUpdate = () => {
    setIdEngagement(null);
    setShowCreateUpdate(false);
  };

  const handleShowDelete = (id) => {
    setIdEngagement(id);
    setShowDelete(true);
  };
  const handleCloseDelete = () => {
    setIdEngagement(null);
    setShowDelete(false);
  };

  const handleShowOrgunits = (id) => {
    setIdEngagement(id);
    setShowOrgunits(true);
  };

  const handleCloseOrgunits = () => {
    setShowOrgunits(false);
  };

  useEffect(() => {
    recupEngagements();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminEngagements.titre")} />
        <span role="button" onClick={() => handleShowCreateUpdate("")}>
          <MdAddCircleOutline size="1.5em" />{" "}
          {t("admin.PageAdminEngagements.buttonAjouterEngagement")}
        </span>
        {loading ? (
          <div style={{ textAlign: "center", flex: 1 }}>
            <Spinner animation="grow" />
          </div>
        ) : (
          <Table striped bordered hover className="stickyTable mt-2">
            <thead>
              <tr>
                <th>{t("admin.PageAdminEngagements.titreColonne1")}</th>
                <th className="text-center">{t("admin.PageAdminEngagements.titreColonne2")}</th>
                <th className="text-center">{t("admin.PageAdminEngagements.titreColonne3")}</th>
                <th className="text-center">{t("admin.PageAdminEngagements.titreColonne4")}</th>
              </tr>
            </thead>
            <tbody>
              {engagements.map((engagement) => (
                <tr key={engagement._id}>
                  <td>{engagement.nom}</td>
                  <td className="text-center">
                    <MdOutlineCategory
                      size="1.5em"
                      role="button"
                      onClick={() => handleShowOrgunits(engagement._id)}
                    />
                  </td>
                  <td className="text-center">
                    <MdOutlineEdit
                      size="1.5em"
                      role="button"
                      onClick={() => handleShowCreateUpdate(engagement._id)}
                    />
                  </td>
                  <td className="text-center">
                    <MdDeleteOutline
                      size="1.5em"
                      role="button"
                      onClick={() => handleShowDelete(engagement._id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Container>
      <ModalCreateUpdate
        show={showCreateUpdate}
        id={idEngagement}
        handleClose={handleCloseCreateUpdate}
        handleRecupDatas={recupEngagements}
      />
      <ModalDelete
        show={showDelete}
        id={idEngagement}
        handleClose={handleCloseDelete}
        handleRecupDatas={recupEngagements}
      />
      <ModalChoixOrgunits
        show={showOrgunits}
        idEngagement={idEngagement}
        handleClose={handleCloseOrgunits}
        ReduxInstanceId={ReduxInstance._id}
      />
    </>
  );
};

export default PageAdminEngagements;
